/**
 * Produces a stable, order-independent string key from the sort model.
 *
 * Used as a useEffect dep so column reorder (which changes columnStates order
 * but not the sort config) does NOT trigger a spurious data refetch.
 */
export const computeSortModelKey = (
  sortModel: ReadonlyArray<{columnKey: string; order: string}>
): string =>
  [...sortModel]
    .sort((a, b) => a.columnKey.localeCompare(b.columnKey))
    .map((s) => `${s.columnKey}:${s.order}`)
    .join(',');
